import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import Loader from "components/Loader";
import ProductsQuantity from "components/Header/ProductsQuantity";
import Totals from "./Totals";
import TooltipError from "components/TooltipError";
import CartService from "services/Cart";
import PubSub from "services/PubSub/";
import CartAction from "actions/Cart";
import UpdatePhone from "components/Header/MiniCart/UpdatePhone";
import Product from "components/Header/MiniCart/Content/Product";
import {addClass, hasClass, removeClass} from "utils";
import UserActions from 'actions/User';
import Day from 'dayjs';
import StorageService from "services/StorageService/";
import TagManagerService from 'services/TagManager';
import { checkoutID } from 'config';
import useVariant from 'hooks/useVariant';
import Price from "components/Price";
import CmsService from "services/CMS";
import { withRouter } from "react-router-dom";
import NewRelicService from 'services/NewRelic'

let actions = [];

const Content = (props) => {

    const {quantity, orderForm, loading, setOpenCart} = props;
    const isEmpty = orderForm && orderForm.items ? orderForm.items.length === 0 : true;
    const [actionError, setActionError] = useState(false);
    const [updatePhone, setUpdatePhone] = useState(false);
    const [checkout, setCheckout] = useState(false);
    const [maxAmountPrice, setMaxAmountPrice] = useState('');
    const [minPurchase, setMinPurchase] = useState(0);
    const [userData, setUserData] = useState(StorageService.getSecureItem('userData'));

    const messageQuestion = "¿Estás seguro que deseas vaciar el carro?";

    const variant = useVariant(checkoutID);
    const newVariant = variant === '1';


    const goToCheckout = () => {
        setUserData(StorageService.getSecureItem('userData'));
        let user = StorageService.getSecureItem('userData');

        if((user && !user.tel_update) && (!updatePhone || updatePhone==='false' || updatePhone==='undefined')){
            setCheckout(true);
            NewRelicService.sendPageAction({
                action: 'UpdatePhoneInMinicart',
                payload:{
                    status: 'open'
                }
            })
        }else{
            setCheckout(false);
            CartService.goToCheckout(props.history, newVariant);
            setOpenCart(false)
        }
    };

    const addToList = () => {
        PubSub.dispatch('add_to_list_open', { orderItems: window ? window.orderItems : {} });
    };

    const activeSearch = () => {
        PubSub.dispatch('toggle_search');

        const $headerSearchContainer = document.querySelector('.header-search-container');
        if(hasClass($headerSearchContainer, 'open')){
            removeClass($headerSearchContainer, 'open');
        }else{
            addClass($headerSearchContainer, 'open');
        }
    };

    const openEmptyCart = () =>  {
        PubSub.dispatch('modal_confirmation_open', {
            title: `Vaciar carro`,
            message: messageQuestion,
            cancelBtnText: 'Volver',
            confirmBtnText: 'Vaciar',
            confirmCallback: () => {
                setTimeout(() => {
                    emptyCart();
                },0)

            }
        });
    }

    const getValueTotalizers = (id) => {
        const items = orderForm && orderForm.totalizers && orderForm.totalizers.length ? orderForm.totalizers.filter(item => item.id === id) : {};
        return items[0] ? Math.abs(items[0].value) : 0;
    };

    const emptyCart = () => {
        TagManagerService.removeAllItemsCart(orderForm.items, 'Mini Cart empty cart');

        const emptyCartPromise = CartAction.clearCart().then((orderFormPromise) => {
            setActionError(!orderFormPromise || orderFormPromise.isOld);
            return orderFormPromise;
        });

        PubSub.dispatch('cart_productRemove', {promise: emptyCartPromise});
    };

    const clickOutTooltip = () => {
        setActionError(false);
    };

    const responseUpdatePhone = (response) => {
        setUserData(StorageService.getSecureItem('userData'));
        let user = StorageService.getSecureItem('userData');

        if(response && response.value && (typeof response.value.results.value === 'boolean')){
            setTimeout(() => {
                setUpdatePhone(true);
                setCheckout(false);
                CartService.goToCheckout(props.history, newVariant);
            },0);

        }else if(response && response.value){
            setTimeout(() => {
                let data = user;
                data.tel_update = true;
                StorageService.setSecureItem('userData',data);
                setUpdatePhone(true);
                setCheckout(false);
                CartService.goToCheckout(props.history, newVariant);
            },0);
        }

    };

    useEffect(() => {
        actions.push(PubSub.register('update_phone_user', responseUpdatePhone));

        
        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = []
        }
    }, []);

    useEffect(() => {
        if(userData)
            setUpdatePhone(userData.tel_update);

    }, [userData]);

    useEffect(() => {

        if(orderForm){
            CmsService.getOperationsV2().then((data) => {
                if(data && data.config_purchase){
                    const configPurchase = data.config_purchase && data.config_purchase.minimum_purchase ? data.config_purchase.minimum_purchase * 1 : 0;

                    const itemDiscount = orderForm?.totalizers?.filter(item => item.id === 'Discounts');
                    const discount = itemDiscount && itemDiscount.length ? itemDiscount[0].value : 0;

                    const itemTotalizer = orderForm?.totalizers?.filter(item => item.id === 'Items');
                    const total = itemTotalizer && itemTotalizer.length ? (itemTotalizer[0].value  + discount): 0;

                    if((configPurchase > (total / 100))){
                        setMinPurchase(configPurchase);
                    }else{
                        setMinPurchase(null);
                    }

                }
            })
        }

    }, [orderForm]);

    const callbackServices = (phone)=>{
        const userData = StorageService.getSecureItem('userData');
        if (phone) {
            let updateUser = {
                email: userData.email,
                firstName: userData.firstName,
                lastName: userData.lastName,
                document: userData.document ? userData.document : '',
                documentType: "RUT",
                phone: phone,
                corporateName: null,
                tradeName: null,
                corporateDocument: null,
                stateInscription: null,
                corporatePhone: null,
                isCorporate: false,
                profileCompleteOnLoading: false,
                profileErrorOnLoading: false,
                customerClass: null
            }

            CartAction.setProfileData(updateUser).then(client => {
                if(client && client.clientProfileData){
                    return UserActions.setNumber({phone: '+56'+phone, tel_update:true, tel_update_date: Day().format()});
                }else{
                    return Promise.resolve(false);
                }
            })
        }else{
            return Promise.resolve(false);
        }
    }

    const openDeliverySelector = () => {
        PubSub.dispatch('delivery_selector_open');
        PubSub.dispatch('toggle_minicart', {state: false});
    }


    const alertAmount = (maxAmount, block) => {
        const maxPrice = "$ " + (Math.round(maxAmount)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        if(block) {
            setMaxAmountPrice(maxPrice);
        } else {
            setTimeout(() => {
                PubSub.dispatch('open_snackbar',{
                    Subtitle: `Estás próximo a alcanzar el <strong>monto máximo de ${maxPrice} por día.</strong>`,
                    timer: 5000,
                    type: 'maxAmountInCart'
                });
            },0);
            setMaxAmountPrice(false);
        }
    }

    if(userData && checkout) {
        return <div className="minicart update-phone"><UpdatePhone phone={userData.homePhone} callbackServices={callbackServices}/></div>;
    } else {

        const discount = getValueTotalizers('Discounts');
        const subTotal = getValueTotalizers('Items') - discount;

        const disabledPurchase = (!subTotal);

        return <div className="minicart">
            {loading && <div className="minicart-loader">
                <Loader />
            </div>}
            {isEmpty && <div className="minicart-empty">
                <strong >Tu carro está vacío</strong><span className="still-empty">Navega por las ofertas y categorías</span>
                <div className="primary-btn empty-cart-btn" onClick={() => activeSearch()}>
                    <span className="cart-actions-search-products">Inténtalo aquí</span>
                </div>
            </div>}
            {!isEmpty && <div className="minicart-full">
                <div className="minicart-cant-prods">
                    <strong>Tienes <ProductsQuantity text={true} quantity={quantity} /></strong><br/>
                </div>
                <div className="minicart-prods">
                    {orderForm && orderForm.items.map((item, index) =>
                        <Product item={item} position={index} key={item.id + index} />
                    )}
                </div>

                {!subTotal && !(minPurchase) && <div className="minicart-totals-delivery-alert">
                    En este momento <strong>no tenemos horarios disponibles</strong> para tu despacho. Puedes <span onClick={()=>openDeliverySelector()}>cambiar de modo de entrega</span> para ver más posibilidades.
                </div>}


                {(disabledPurchase) ? '' : <Totals totalizers={orderForm.totalizers || []} alertAmount={alertAmount}/>}

                {(maxAmountPrice) &&
                <div className='express-alert'>Tu pedido excede el <strong>monto máximo diario de { maxAmountPrice }.</strong> <br/>Para continuar edita tu pedido o crea una lista para guardar tus productos.</div>
                }
                {!!(minPurchase) && <span className="minimum-alert">Monto mínimo de compra <strong> <Price price={minPurchase}/></strong> </span>}

                <div className="minicart-actions">
                    <button className={'primary-btn' + (disabledPurchase ? ' disabled-btn' : '')} onClick={goToCheckout} >
                        Hacer pedido
                    </button>
                    <div className="minicart-sec-actions">
                        <a className="mini-save btn btn-secudary" onClick={addToList}>
                            Guardar
                        </a>
                        <span className='minicart-actions-separator'/>
                        <a className={'mini-empty btn btn-secudary' + (loading ? ' disabled' : '')} onClick={openEmptyCart}>
                            {actionError && <TooltipError message='En este momento no podemos completar tu solicitud.' clickOut={clickOutTooltip}/>}
                            Vaciar carro
                        </a>
                    </div>
                </div>
            </div>}
        </div>;
    }
};

Content.propTypes = {
    loading: PropTypes.bool,
    orderForm: PropTypes.object,
    quantity: PropTypes.number
};

export default withRouter(Content);
